import { Outlet } from 'react-router-dom';

export default function GuestWaiverLayout() {
  return (
    <div className="h-[100dvh] overflow-y-auto overflow-x-hidden bg-white">
      <Outlet />
    </div>
  );
}
